import React from 'react';

/**
 * Xénicos brand logo — "XÉNICOS · Decisiones con claridad".
 * Single PNG asset shipped from `/public`. Width scales proportionally with
 * the requested `height`. The image already has a transparent-friendly dark
 * background suited for the app's primary dark theme; on light surfaces it
 * also reads correctly because the wordmark uses the brand blues.
 *
 * Props:
 *   height       (px)  Display height. Width derived from the source aspect ratio (1:1).
 *   ariaLabel    (str) Accessible label.
 *   className    (str) Extra CSS classes.
 *   style        (obj) Extra inline styles.
 *   variant      ('full'|'icon') 'full' shows the wordmark + tagline; 'icon' only the X.
 */
const LogoHorizontal = ({ height = 32, ariaLabel = 'XÉNICOS — Decisiones con claridad', className = '', style = {}, variant = 'full' }) => {
  const src = variant === 'icon'
    ? `${process.env.PUBLIC_URL || ''}/xenicos-icon-192.png`
    : `${process.env.PUBLIC_URL || ''}/xenicos-logo-full.png`;
  return (
    <img
      src={src}
      alt={ariaLabel}
      height={height}
      style={{ height: `${height}px`, width: 'auto', objectFit: 'contain', display: 'block', ...style }}
      className={className}
      draggable={false}
    />
  );
};

export default LogoHorizontal;
